import React, { useEffect, useRef } from 'react'
import { useRaportForm } from '../../context/RaportFormContext'
import Options from './stages/Options'
import CheckboxWithLabelField from '@/modules/drivers/forms/contract/inputs/CheckboxWithLabelField'
import StageHeader from '@/modules/drivers/forms/shared/StageHeader'
import { faSlidersSolid } from '@/lib/fa'
import { DividerHorizontal } from '@/modules/drivers/shared/DividerHorizontal'
import { FieldsetSelect } from '@/modules/settings/components/FieldsetSelect'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { ReportType } from '@/app/constants/reportType'
import { getReportNumberByType } from '@/app/services/printout/reportTypeResolver'
import usePrintOutService from '../../services/PrintOutService'
const BUSINESS_TRIP_OPTIONS = [
  {
    label: 'printout.tripReportBeginingAt',
    value: '0',
  },
  {
    label: 'printout.tripReportEndingAt',
    value: '1',
  },
  {
    label: 'printout.tripReportCalculatedAt',
    value: '2',
  },
  {
    label: 'printout.tripReportSettlementDateAt',
    value: '3',
  },
  {
    label: 'printout.tripReportModifiedAt',
    value: '6',
  },
]
type DelegationsProps = {
  withOnlyPolish?: boolean
  // Podane razem: lista startuje od filtra zapamiętanego dla raportu, jak w WPF.
  rememberedFilterReport?: ReportType
  companyId?: string
}

const Delegations = ({
  withOnlyPolish = true,
  rememberedFilterReport,
  companyId,
}: DelegationsProps) => {
  const { data, setData } = useRaportForm()
  const { t } = useLocalize()
  const { getReportTripFilter } = usePrintOutService()
  const filterTouched = useRef(false)
  const remembersFilter = Boolean(rememberedFilterReport && companyId)

  useEffect(() => {
    setData({
      // Zapamiętany filtr dochodzi z serwera; do tego czasu pole zostaje puste,
      // żeby wczesne „Potwierdź" nie nadpisało go wartością domyślną.
      ...(remembersFilter ? {} : { tripReportOption: 0 }),
      onlySettled: true,
      ...(withOnlyPolish ? { onlyPolish: true } : {}),
      separateFiles: false,
      issuerSignature: false,
      driverSignature: false,
    })
  }, [])

  useEffect(() => {
    if (!rememberedFilterReport || !companyId) {
      return undefined
    }
    let cancelled = false
    const applyFilter = (tripReportOption: number) => {
      if (cancelled || filterTouched.current) {
        return
      }
      setData((prev) => ({ ...prev, tripReportOption }))
    }
    getReportTripFilter({
      companyId,
      reportType: getReportNumberByType(rememberedFilterReport),
    })
      .then((tripFilter) => {
        const known = BUSINESS_TRIP_OPTIONS.some(
          (option) => option.value === String(tripFilter),
        )
        applyFilter(known ? tripFilter : 0)
      })
      .catch(() => applyFilter(0))
    return () => {
      cancelled = true
    }
  }, [])
  const businessOptions = Object.values(BUSINESS_TRIP_OPTIONS).map((ct) => ({
    value: ct.value,
    label: t(ct.label),
  }))
  return (
    <div className="tw-flex-1 tw-space-y-4 tw-overflow-auto tw-p-4 tw-pr-8">
      <div className="tw-flex tw-items-start">
        <StageHeader title={t('printout.data')} textSize="sm" icon={faSlidersSolid} />
        <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-1 sm:tw-min-w-[400px]">
          <FieldsetSelect
            label={t('printout.business-trips')}
            placeholder={t('common.select')}
            value={
              data?.tripReportOption !== undefined
                ? data.tripReportOption.toString()
                : remembersFilter
                  ? ''
                  : '0'
            }
            name="tripReportOption"
            onChange={(e) => {
              filterTouched.current = true
              setData({
                ...data,
                tripReportOption: Number(e.target.value),
              })
            }}
            searchEnabled={false}
            options={businessOptions}
          />
          {withOnlyPolish && (
            <CheckboxWithLabelField
              field="onlyPolish"
              data={data}
              setData={setData}
              label={t('printout.only-domestic-delegations')}
            />
          )}
          <CheckboxWithLabelField
            field="onlySettled"
            data={data}
            setData={setData}
            label={t('printout.only-settled')}
/>
        </div>
      </div>
      <DividerHorizontal />
      <Options
        setData={setData}
        data={data}
        vehicleActivity={false}
        separateFilesOnly={false}
      />
    </div>
  )
}

export default Delegations
